{
  "title": "Ajustes",
  "tabs": {
    "provider": "Proveedor",
    "connection": "Conexión",
    "appearance": "Apariencia",
    "agent": "Agente",
    "features": "Func.",
    "mcp": "MCP"
  },
  "appearance": {
    "themeHeading": "Tema",
    "themeLight": "Claro",
    "themeDark": "Oscuro",
    "themeSystem": "Sistema",
    "themeSystemHint": "Sistema sigue tu preferencia de claro/oscuro del sistema operativo.",
    "preferencesHeading": "Preferencias",
    "compactDensity": "Densidad compacta",
    "compactDensityHint": "Espaciado más reducido en todo el chat.",
    "soundOnComplete": "Sonido al completar",
    "soundOnCompleteHint": "Reproduce un tono suave cuando termina una ejecución.",
    "titleAnimation": "Animación del título",
    "titleAnimationHint": "Muestra un título animado en la terminal del CLI.",
    "languageHeading": "Idioma",
    "languageLabel": "Idioma de la interfaz",
    "languageHint": "Cambia solo el texto de la interfaz. Los prompts, las habilidades y la salida del modelo no se ven afectados."
  },
  "model": {
    "heading": "Modelo",
    "loading": "Cargando modelos...",
    "notFound": "No se encontraron modelos para este proveedor. El catálogo podría estar vacío o cargándose.",
    "selectProviderFirst": "Selecciona un proveedor primero",
    "context": "{{count}}k contexto"
  },
  "connection": {
    "wsUrlLabel": "URL del servidor WebSocket",
    "wsUrlPlaceholder": "ws://localhost:3457",
    "wsUrlHint": "URL del servidor WebSocket del agente. El servidor se ejecuta junto con el CLI.",
    "startingHeading": "Iniciar el servidor WebSocket",
    "startingBody": "Independiente: ejecuta ./dev.ps1 desde la raíz del repo, o establece WS_HOST/WS_PORT antes de lanzar wstackui. O junto a la CLI: wstack --webui."
  },
  "provider": {
    "subscriptionHeading": "Inicio de sesión con suscripción",
    "apiKeysHeading": "Proveedores de clave de API",
    "apiKeysBody": "Elige un proveedor del catálogo y añade una clave de API, o gestiona los proveedores guardados.",
    "tabCatalog": "Catálogo",
    "tabSaved": "Guardados ({{count}})",
    "searchPlaceholder": "Buscar entre {{count}} proveedores (nombre / id / familia)…",
    "loadingCatalog": "Cargando catálogo...",
    "noMatch": "Ningún proveedor coincide con «{{query}}».",
    "configured": "Configurado",
    "reachable": "Alcanzable",
    "envVar": "ENV: {{var}}",
    "modelCount_one": "{{count}} modelo",
    "modelCount_other": "{{count}} modelos",
    "keyPlaceholder": "Clave de API de {{name}}",
    "orEnv": "O define {{env}} en el entorno.",
    "addApiKey": "Añadir clave de API",
    "manageKeys": "Gestiona tus claves de API y configuraciones de proveedor",
    "addProvider": "Añadir proveedor",
    "addCustomHeading": "Añadir proveedor personalizado",
    "localServers": "Servidores locales — haz clic para autocompletar:",
    "providerIdPlaceholder": "ID del proveedor (p.ej. my-llm-server)",
    "apiKeyOptionalPlaceholder": "Clave de API (opcional)",
    "noSaved": "Aún no hay proveedores guardados",
    "noSavedHint": "Añade un proveedor para empezar",
    "apiKeysLabel": "Claves de API",
    "addKey": "Añadir clave",
    "noKeys": "Ninguna clave configurada",
    "active": "Activa",
    "setActive": "Definir como activa",
    "keyLabelPlaceholder": "Etiqueta de la clave (p.ej. default, production)",
    "apiKeyPlaceholder": "Clave de API",
    "saveKey": "Guardar clave",
    "savedToast": "Clave guardada para {{name}}"
  },
  "mcp": {
    "status": {
      "connected": "Conectado",
      "connecting": "Conectando",
      "sleeping": "Inactivo",
      "discovering": "Descubriendo",
      "error": "Error",
      "stopped": "Detenido",
      "unknown": "Desconocido"
    },
    "disabled": "Los servidores MCP están deshabilitados.",
    "wakeTitle": "Despertar servidor",
    "sleepTitle": "Poner en reposo",
    "discoverTitle": "Descubrir herramientas",
    "editTitle": "Editar",
    "removeTitle": "Eliminar",
    "statusLabel": "Estado:",
    "enabledLabel": "Activado:",
    "yes": "Sí",
    "no": "No",
    "descriptionLabel": "Descripción:",
    "pidLabel": "PID:",
    "errorLabel": "Error:",
    "toolsLabel": "Herramientas ({{count}}):",
    "noTools": "Aún no se han descubierto herramientas",
    "serverNameRequired": "El nombre del servidor es obligatorio",
    "dialogTitleEdit": "Editar servidor MCP",
    "dialogTitleAdd": "Añadir servidor MCP",
    "dialogTitleAddCustom": "Añadir servidor MCP personalizado",
    "fieldName": "Nombre",
    "fieldNamePlaceholder": "p.ej. github, filesystem",
    "fieldTransport": "Transporte",
    "fieldUrl": "URL",
    "fieldCommand": "Comando",
    "fieldCommandPlaceholder": "p.ej. npx",
    "fieldArgs": "Args",
    "fieldArgsHint": "(separados por espacios)",
    "fieldArgsPlaceholder": "p.ej. -y @modelcontextprotocol/server-github",
    "fieldEnv": "Variables de entorno",
    "fieldEnvHint": "(KEY=valor, una por línea)",
    "fieldDescription": "Descripción",
    "fieldDescriptionPlaceholder": "Servidor MCP de GitHub para acceso al repositorio",
    "enableServer": "Activar servidor",
    "lazyConnect": "Conexión diferida",
    "lazyConnectHint": "(no iniciar hasta la primera llamada; entra en reposo al estar inactivo)",
    "saveChanges": "Guardar cambios",
    "addServer": "Añadir servidor",
    "requires": "Requiere: {{vars}}",
    "added": "Añadido",
    "heading": "Servidores MCP",
    "summary": "{{connected}} conectados · {{sleeping}} inactivos · {{total}} en total",
    "addCustom": "Personalizado",
    "tabRecommended": "Recomendados",
    "tabServers": "Servidores",
    "tabAddCustom": "Personalizado",
    "recommendedBody": "Añadido con un clic para servidores MCP populares. Haz clic en Añadir para preconfigurar y luego confirma. Los servidores que requieren credenciales necesitarán sus variables de entorno antes de usarse.",
    "loadingServers": "Cargando servidores...",
    "noServers": "No hay servidores MCP configurados",
    "noServersHint": "Cambia a la pestaña Recomendados para añadir servidores populares, o Personalizado para los tuyos.",
    "addCustomBody": "Configura un servidor MCP personalizado con transporte stdio, SSE o HTTP.",
    "addCustomBodyHint": "Para servidores populares usa mejor la pestaña Recomendados — todo está preconfigurado.",
    "removeConfirmTitle": "¿Eliminar el servidor «{{name}}»?",
    "removeConfirmBody": "Esto elimina el servidor MCP de tu configuración.",
    "toastAdded": "Servidor «{{name}}» añadido",
    "toastRemoved": "Servidor «{{name}}» eliminado",
    "toastDiscovered": "Descubiertas {{count}} herramientas de «{{name}}»",
    "toastSleeping": "El servidor «{{name}}» está inactivo",
    "toastConnected": "Servidor «{{name}}» conectado",
    "toastReconnected": "Servidor «{{name}}» reconectado",
    "toastDisconnected": "Servidor «{{name}}» desconectado: {{reason}}",
    "toastError": "Servidor «{{name}}» error: {{error}}",
    "disabledHint": "Habilita el indicador \"Servidores MCP\" en la pestaña Funciones para usar esta sección."
  },
  "allowlist": {
    "title": "¿Borrar la allowlist guardada?",
    "body_one": "Esto eliminará el modelo fijado para {{provider}}. El selector de modelos volverá al catálogo models.dev.",
    "body_other": "Esto eliminará los {{count}} modelos fijados para {{provider}}. El selector de modelos volverá al catálogo models.dev.",
    "undoHint": "Puedes deshacerlo durante 8 segundos tras confirmar.",
    "keepTitle": "Conservar allowlist (Esc)",
    "clearTitle": "Borrar allowlist (Enter)",
    "clear": "Borrar allowlist"
  },
  "oauth": {
    "termsWarning": "Inicia sesión con una suscripción en lugar de una clave API. Usar una suscripción fuera de su cliente oficial puede violar los Términos del proveedor — tu cuenta podría ser limitada o baneada. Una clave API es la vía sancionada para uso programático.",
    "signIn": "Iniciar sesión",
    "waitingBrowser": "Esperando tu inicio de sesión…",
    "openSignIn": "Abrir página de inicio de sesión",
    "pasteLoopbackBusy": "Puerto loopback ocupado — pega la URL de redirección",
    "pasteCantReach": "¿El navegador no llega a este servidor? Pega la URL de redirección",
    "submit": "Enviar",
    "enterCode": "Introduce este código en la página de verificación:",
    "openVerification": "Abrir página de verificación",
    "waitingCode": "Esperando autorización…",
    "exchanging": "Intercambiando tokens…",
    "fetchingModels": "Obteniendo modelos…",
    "signedIn": "Sesión iniciada.",
    "signedInToast": "Sesión iniciada — {{provider}}",
    "signInFailed": "Inicio de sesión fallido"
  },
  "agent": {
    "modelHeading": "Modelo",
    "autonomyHeading": "Autonomía y Comportamiento",
    "autonomyModeLabel": "Modo de autonomía",
    "autonomyModeHint": "Qué tan independientemente procede el agente entre turnos.",
    "autonomyModeOff": "Desactivado — control manual total",
    "autonomyModeSuggest": "Sugerir — sugiere los siguientes pasos",
    "autonomyModeAuto": "Auto — breve retardo de confirmación",
    "autonomyModeEternal": "Eterno — autónomo hasta completar el objetivo",
    "autonomyModeEternalParallel": "Eterno Paralelo — flota multi-agente",
    "autoProceedDelayLabel": "Retardo de auto-progreso",
    "autoProceedDelayHint": "Milisegundos antes de que el agente auto-progrese en modo Auto. 0 = inmediato.",
    "yoloLabel": "Modo YOLO",
    "yoloHint": "Omitir los prompts de confirmación de herramientas — el agente corre sin preguntar.",
    "refineHeading": "Refinamiento de Prompt",
    "enableRefineLabel": "Activar refinamiento",
    "enableRefineHint": "Reescribe los prompts antes de enviar — instrucciones más claras, mejores resultados.",
    "refineDelayLabel": "Retardo de refinamiento",
    "refineDelayHint": "Cuenta atrás antes del envío automático del prompt refinado.",
    "refineLanguageLabel": "Idioma de refinamiento",
    "refineLanguageHint": "Conserva tu idioma o traduce al inglés para el modelo.",
    "refineLanguageOriginal": "Original — conserva tu idioma",
    "refineLanguageEnglish": "Inglés — traducir al inglés",
    "reasoningHeading": "Razonamiento y Caché",
    "reasoningModeLabel": "Modo de razonamiento",
    "reasoningModeHint": "Controla cómo el modelo usa el pensamiento extendido. Auto = predeterminado del proveedor.",
    "reasoningModeAuto": "Auto — predeterminado del proveedor",
    "reasoningModeOn": "Activado — forzar pensamiento",
    "reasoningModeOff": "Desactivado — desactivar pensamiento",
    "reasoningEffortLabel": "Esfuerzo de razonamiento",
    "reasoningEffortHint": "Cuánto compute gasta el modelo pensando. Solo se envía cuando el modelo lo soporta.",
    "reasoningEffortNone": "Ninguno",
    "reasoningEffortMinimal": "Mínimo",
    "reasoningEffortLow": "Bajo",
    "reasoningEffortMedium": "Medio",
    "reasoningEffortHigh": "Alto",
    "reasoningEffortXhigh": "Muy alto",
    "reasoningEffortMax": "Máx",
    "preserveThinkingLabel": "Preservar pensamiento",
    "preserveThinkingHint": "Conserva los bloques de razonamiento entre turnos para la continuidad del contexto.",
    "cacheTtlLabel": "TTL de caché",
    "cacheTtlHint": "Tiempo de vida de la caché de prompts. 1h cuesta más al escribir pero ahorra en relecturas (Anthropic).",
    "cacheTtlDefault": "Predeterminado — predeterminado del proveedor",
    "cacheTtl5m": "5 minutos",
    "cacheTtl1h": "1 hora",
    "capsHint": "Usa wstack models caps para comprobar qué soporta el modelo actual. Los ajustes no soportados se omiten silenciosamente por petición.",
    "fallbackHeading": "Fallbacks de modelo",
    "fallbackBody": "Cuando el modelo activo es rate-limitado (429/529), da error 5xx o se cuelga — tras sus propios retries — el agente rota al siguiente modelo de esta cadena. También usado por defecto para los sub-agentes workers de SDD.",
    "autoFallbackLabel": "Fallback automático",
    "autoFallbackHint": "Cuando la cadena de arriba está vacía, deriva una automáticamente de tus proveedores con clave.",
    "favoritesOnlyLabel": "Solo favoritos",
    "favoritesOnlyHint": "Cuando el fallback automático deriva una cadena, restríngela a tus modelos favoritos.",
    "profilesHeading": "Perfiles de fallback",
    "addProfile": "Añadir",
    "noProfiles": "Aún no hay perfiles de fallback con nombre.",
    "createDefault": "Crear predeterminado desde el modelo activo",
    "useChain": "Usar cadena",
    "setLeader": "Establecer líder",
    "profileEmpty": "El perfil está vacío.",
    "favoritesHeading": "Modelos favoritos",
    "favoritesEmpty": "Los favoritos se muestran primero y pueden restringir el fallback automático.",
    "routingHeading": "Enrutado de modelo",
    "routingRouteKey": "Clave de ruta de modelo",
    "routingPhasesGroup": "Fases",
    "routingRolesGroup": "Roles {{label}}",
    "routingCustomGroup": "Rutas personalizadas existentes",
    "routingTargetPlaceholder": "fallback1, provider/model, o vacío",
    "routingSet": "Establecer",
    "routingReasoningModeAria": "Modo razonamiento nueva ruta",
    "routingReasoningEffortAria": "Esfuerzo razonamiento nueva ruta",
    "routingReasoningPreserveAria": "Preservación razonamiento nueva ruta",
    "routingReasoningModeFor": "Modo razonamiento para {{key}}",
    "routingReasoningEffortFor": "Esfuerzo razonamiento para {{key}}",
    "routingReasoningPreserveFor": "Preservación razonamiento para {{key}}",
    "noRoutes": "Aún no hay rutas de modelo.",
    "leaderModel": "modelo líder",
    "hqHeading": "Cliente HQ",
    "hqPublishingLabel": "Publicación HQ",
    "hqPublishingHint": "Publica esta sesión WebUI/cliente en WrongStack HQ. Los clientes de la misma máquina pueden auto-descubrir la auth HQ local; los remotos usan la URL/token de abajo.",
    "hqUrlLabel": "URL HQ",
    "hqUrlHint": "Déjalo vacío para auto-descubrimiento en la misma máquina.",
    "hqTokenLabel": "Token de cliente HQ",
    "executionHeading": "Ejecución",
    "maxIterationsLabel": "Iteraciones máx por run",
    "maxIterationsHint": "Tope estricto de turnos LLM por agent.run().",
    "autoProceedMaxIterationsLabel": "Iteraciones máx de auto-progreso",
    "autoProceedMaxIterationsHint": "Detiene el auto-progreso tras N iteraciones. 0 = ilimitado.",
    "confirmExitLabel": "Confirmar antes de salir",
    "confirmExitHint": "El primer Ctrl+C aborta el trabajo, el segundo confirma la salida.",
    "chimeLabel": "Timbre al completar",
    "chimeHint": "Campana de terminal cuando termina un run de agente.",
    "fleetHeading": "Flota y Streaming",
    "streamFleetLabel": "Transmitir eventos de flota",
    "streamFleetHint": "Muestra la actividad live de sub-agentes en el panel de flota.",
    "maxConcurrentLabel": "Sub-agentes concurrentes máx",
    "maxConcurrentHint": "Número máximo de sub-agentes que pueden correr simultáneamente.",
    "nextPredictionLabel": "Predicción del siguiente paso",
    "nextPredictionHint": "Tras completar un turno, predice los probables pasos siguientes.",
    "telegramHeading": "Notificaciones de Telegram",
    "telegramSessionEndLabel": "Fin de sesión",
    "telegramSessionEndHint": "Envía un resumen cuando termina una sesión.",
    "telegramDelegateLabel": "Delegado terminado",
    "telegramDelegateHint": "Envía una nota humanizada cuando un sub-agente completa.",
    "telegramLongToolLabel": "Herramientas largas",
    "telegramLongToolHint": "Notifica cuando una herramienta excede {{ms}}ms. 0 para desactivar.",
    "telegramChangesApply": "Los cambios se aplican inmediatamente.",
    "telegramNotConfigured": "Telegram no está configurado. Ejecuta /telegram-setup en la CLI para conectar un bot primero.",
    "addModelToProfile": "Añadir modelo al perfil…",
    "addFavoriteModel": "Añadir modelo favorito…",
    "hqRawContentLabel": "Contenido HQ sin procesar",
    "hqRawContentHint": "Enviar vistas previas de contenido sin procesar a HQ en lugar de vistas previas redactadas."
  },
  "features": {
    "flagsHeading": "Indicadores de Funciones",
    "mcpLabel": "Servidores MCP",
    "mcpHint": "Habilita las integraciones Model Context Protocol.",
    "pluginsLabel": "Plugins",
    "pluginsHint": "Carga y ejecuta los plugins instalados por el usuario.",
    "memoryLabel": "Memoria",
    "memoryHint": "Persiste y recupera hechos entre sesiones.",
    "skillsLabel": "Habilidades",
    "skillsHint": "Carga prompts de habilidades específicas del dominio.",
    "modelsRegistryLabel": "Registro de modelos",
    "modelsRegistryHint": "Usa el catálogo models.dev para el descubrimiento de proveedores.",
    "indexOnStartLabel": "Indexar al inicio",
    "indexOnStartHint": "Construye el índice de símbolos del código al iniciar la sesión.",
    "contextHeading": "Contexto y Depuración",
    "autoCompactLabel": "Auto-compactar contexto",
    "autoCompactHint": "Recorta automáticamente la ventana de contexto cerca de los límites.",
    "compactorStrategyLabel": "Estrategia de compactación",
    "compactorStrategyHint": "Cómo se compacta el contexto cuando crece demasiado.",
    "compactorStrategyHybrid": "Híbrida — reglas rápidas (predeterminado)",
    "compactorStrategyIntelligent": "Inteligente — resumen LLM",
    "compactorStrategySelective": "Selectiva — selección guiada por LLM",
    "contextModeLabel": "Modo de contexto",
    "contextModeHint": "Política de ventana de contexto — equilibrado es el predeterminado.",
    "contextModeBalanced": "Equilibrado — uso normal del contexto",
    "contextModeFrugal": "Frugal — uso conservador de tokens",
    "contextModeDeep": "Profundo — contexto mayor para tareas complejas",
    "contextModeArchival": "Archival — maximiza la retención de contexto",
    "tokenSavingLabel": "Modo de ahorro de tokens",
    "tokenSavingHint": "Cuán agresivamente reducir el uso de tokens.",
    "tokenSavingOff": "Desactivado — sin ahorro",
    "tokenSavingMinimal": "Mínimo — optimización básica",
    "tokenSavingLight": "Ligero — reducción moderada",
    "tokenSavingMedium": "Medio — ahorros significativos",
    "tokenSavingAggressive": "Agresivo — compresión máxima",
    "logLevelLabel": "Nivel de log",
    "logLevelHint": "Severidad mínima para el logging del lado servidor.",
    "logLevelDebug": "Debug — todo",
    "logLevelInfo": "Info — flujo normal",
    "logLevelWarn": "Warn — solo problemas",
    "logLevelError": "Error — solo fallos",
    "auditLevelLabel": "Nivel de auditoría",
    "auditLevelHint": "Nivel de detalle para los logs de auditoría de sesión.",
    "auditLevelMinimal": "Mínimo — solo errores",
    "auditLevelStandard": "Estándar — llamadas de herramientas + errores",
    "auditLevelFull": "Completo — cada evento (logs grandes)"
  },
  "toast": {
    "switchingTo": "Cambiando a {{provider}} / {{model}}…",
    "fallbackExists": "El perfil de fallback \"{{name}}\" ya existe",
    "selectProviderModelFirst": "Selecciona un proveedor y un modelo primero",
    "defaultProfileCreated": "Perfil de fallback predeterminado creado",
    "profileEmpty": "El perfil de fallback \"{{name}}\" está vacío",
    "leaderSetFrom": "Líder establecido desde {{name}}"
  }
}
